import { PropsWithChildren } from 'react';
import { FlagProvider, IConfig, useFlagsStatus } from '@unleash/proxy-client-react';
import { useAuthUser } from '@frontegg/react';
import { Loader } from '@common/ui/Loader';
import ErrorPage from '@common/pages/ErrorPage';

const getDefaultConfig = () => ({
  url: `${window.location.protocol}//${window.location.host}/api/v1/feature-flags`,
  refreshInterval: 0,
  disableMetrics: true,
  appName: 'default',
  environment: 'default',
  clientKey: 'proxy-client-key',
});

function FeatureFlagsProvider({ children }: PropsWithChildren) {
  const user = useAuthUser();

  const config: IConfig = {
    ...getDefaultConfig(),
    clientKey: `Bearer ${user.accessToken}`,
    context: { userId: user?.id },
  };

  return (
    <FlagProvider config={config}>
      <FeatureFlagsWrapper>{children}</FeatureFlagsWrapper>
    </FlagProvider>
  );
}

function FeatureFlagsWrapper({ children }: PropsWithChildren) {
  const { flagsReady, flagsError } = useFlagsStatus();

  if (!flagsReady) return <Loader absolute />;

  if (flagsError) return <ErrorPage errorCode={500} errorMessage={flagsError} />;

  return <>{children}</>;
}

export default FeatureFlagsProvider;
